import { postalCodeConstants } from '../_constants';

export function postalCodes(state = {}, action) {
    switch (action.type) {
    case postalCodeConstants.GETALL_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case postalCodeConstants.GETALL_SUCCESS:
        return {
            postalCodes: action.postalCodes,
        };
    case postalCodeConstants.GETALL_FAILURE:
        return {
            error: action.error,
        };
    case postalCodeConstants.FIND_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case postalCodeConstants.FIND_SUCCESS:
        return {
            postalCode: action.postalCode,
        };
    case postalCodeConstants.FIND_FAILURE:
        return {
            error: action.error,
        };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/postalCodes.reducer.js